<template>
	<div>
		<b-modal id="edit-trucker" scrollable ref="edit-trucker" style="margin-top:-45px" size="lg" hide-footer :title="$t('message.EDIT_TRUCKER')" :no-close-on-backdrop="true">
			<h5> {{ $t('message.USER_INFO')}} </h5>
            <hr>
			<div class="row">
				<div class="col-md-6 form-group">
					<label class="label">{{ $t('message.NAME')}}</label>
                    <input name="name" v-model="name" type="text" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('name') }" autocomplete="off"> 
                    <span v-show="errors.has('name')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span> </div>
               <div class="col-md-6 form-group">
					<label class="label">{{ $t('message.EMAIL')}}</label>
					<input name="email" v-model="email" type="email" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('email') }" autocomplete="off"> 
                    <span v-show="errors.has('email')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span> </div>
				<div class="col-md-6 form-group">
					<label class="label">CVR</label>
					<input name="cvr" v-model="cvr" type="text" class="form-control" v-validate="'required|min:8|max:8'" :class="{'is-invalid': errors.has('cvr') }" autocomplete="off"> 
                    <span v-show="errors.has('cvr')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD_MIN_8') }}</span> </div>
				<div class="col-md-6 form-group">
					<label class="label">{{ $t('message.TRUCK_NUMBER')}} </label>
					<input name="dr_number" v-model="dr_number" type="number" class="form-control" v-validate="'required|min:6|max:6'" :class="{'is-invalid': errors.has('dr_number') }" autocomplete="off"> 
                    <span v-show="errors.has('dr_number')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD_MIN_6') }}</span>
                </div>					
				<div class="col-md-6 form-group">
					<label class="label">{{ $t('message.TELEPHONE')}}</label>
                    <input name="phone" v-model="phone" type="number" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('phone') }" autocomplete="off"> 
                    <span v-show="errors.has('phone')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
                </div>
                <div class="col-md-6 form-group">
					<label class="label">{{ $t('message.UNDERVOGN')}}</label>
                    <input name="undervogn" v-model="undervogn" type="text" class="form-control"  :class="{'is-invalid': errors.has('undervogn') }" autocomplete="off"> 
                    <span v-show="errors.has('undervogn')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
                </div>
            </div>
			<div class="row" v-if="address_status == true">
				<div class="col-md-6 form-group">
					<label class="label">Adresse</label>
                    <input name="address" v-model="address" type="text" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('address') }" autocomplete="off"> 
                    <span v-show="errors.has('address')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span> </div>
               <div class="col-md-6 form-group">
					<label class="label">{{ $t('message.CITY')}}</label>
					<input name="city" v-model="city" type="text" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('city') }" autocomplete="off"> 
                    <span v-show="errors.has('city')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span> </div>
				<div class="col-md-6 form-group">
					<label class="label">{{ $t('message.ZIP_CODE')}}</label>
					 <input name="zip_code" v-model="zip_code" type="text" class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('zip_code') }" autocomplete="off"> 
                    <span v-show="errors.has('zip_code')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span> </div> </div>
              <h5> {{ $t('message.VEHICLE')}} </h5>
              <hr>
			<div class="row">
				<div class="col-md-6 form-group">
					<label class="label">{{ $t('message.CAR_NUMBER')}}: </label>
                    <input name="reg_number" v-model="reg_number" readonly type="text" class="form-control" autocomplete="off"> 
                </div>
                <div class="col-md-6 form-group">
					<label class="label">{{ $t('message.FRAME_NO')}}</label>
					<input name="frame_number" v-model="frame_number" readonly type="text" class="form-control" autocomplete="off"> 
                </div>
			 </div>
			<h5> {{ $t('message.SEND_REQUEST') }}  </h5> <span style="display: inline-flex;">
            <b-form-checkbox id="checkbox-1" v-model="car" class="mr-4" name="checkbox-1" value="1" unchecked-value="0">
                {{ $t('message.CAR') }} 
            </b-form-checkbox>
             <b-form-checkbox id="checkbox-2" v-model="insurance" name="checkbox-2" value="1" unchecked-value="0">
                {{ $t('message.INSURANCE') }} 
            </b-form-checkbox>
            </span>
			<br />
		<hr> <span class="float-right">
        <b-button class="btn btn-info mr-2"   @click="edit_truckers()">{{ $t('message.UPDATE') }}</b-button>
        <b-button class=" btn btn-danger"   @click="$bvModal.hide('edit-trucker')"> {{ $t('message.CLOSE') }} </b-button>
        </span> </b-modal>
	</div>
</template>
<script>

export default {
    data () {
      return {
          name:'',
          address_status:false,
          email:'',
          phone:'',
          cvr:'',
          address:'',
          city:'',
          zip_code:'',
          frame_number:'',
          dr_number:'',
          reg_number:'',
          car:'0',
          insurance:'0',
          id:'',
          address_id:'',
          undervogn: '',
      }
    },

    methods:{
        async edit_truckers(){
                const valid = await this.$validator.validateAll()
            if (valid) {
                
                let form_data = {
                    name:this.name,
                    cvr: this.cvr,
                    email: this.email,
                    reg_number: this.reg_number,
                    address:this.address,
                    city:this.city,
                    zip_code :this.zip_code,
                    phone: this.phone,
                    undervogn: this.undervogn,
                    dr_number: this.dr_number,
                    is_car_insurance: this.car,
                    is_work_insurance : this.insurance,
                    address_id:this.address_id,
                    id:this.id,
                    locale:localStorage.getItem('lang')

                }

                if(this.car == '0')
                {
                    this.$store.dispatch("notifications_alert/error", this.$t('message.SELECT_CAR_OPTION'))
                    return

                }

                let loader = this.$loading.show()


                try 
                {
                     await this.$store.dispatch('trucker/update_trucker', form_data)
                    this.$store.dispatch("notifications_alert/success", this.$t('message.MSG_UPDATE_SUCC'))
                    this.$refs['edit-trucker'].hide()
                    loader.hide()

                } 
                catch (e) 
                {
                    loader.hide()
                    this.$store.dispatch("notifications_alert/error", e.response.data.message)
                }
            }
        },
        show(trucker)
        {
            this.reset_form();
            this.id = trucker.id
            this.name = trucker.name
            this.email =trucker.email
            this.cvr = trucker.cvr
            this.dr_number = trucker.truck_number
            this.reg_number = trucker.vehicle ? trucker.vehicle.reg_number : ''
            this.frame_number = trucker.vehicle ? trucker.vehicle.serial_number : ''
            this.car = trucker.is_car_insurance
            this.insurance = trucker.is_work_insurance
            this.phone = trucker.phone_number
            this.undervogn = trucker.undervogn
            if(trucker.address)
            {
                this.address_id = trucker.address.id
                this.address = trucker.address.address
                this.city =  trucker.address.city
                this.zip_code = trucker.address.zip_code
                this.address_status = true
            }
            else
            {
                this.address_status = false
            }
            this.$refs['edit-trucker'].show()
        },
        reset_form(){
            this.name = '',
            this.email = '',
            this.reg_number = '',
            this.frame_number = '',
            this.cvr = '',
            this.phone = '',
            this.undervogn = '',
            this.address = null ,
            this.city = null,
            this.zip_code = null
        }
    }
}
</script>
<style  >
.modal-content{
    margin-top: -66px !important;
}
#sms-verification .modal-content {
	margin-top: 100px !important;
} 
</style>